module.exports = __webpack_public_path__ + "static/media/Hotel-3@2x.c808cfd6.png";